export default "__VITE_ASSET__BwnGf6Bz__"